import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { getAppDashboardURL } from '@/utils/helpers';

export const NoBillingReminderTemplate = () => {
  const { t } = useTranslation();

  return (
    <>
      <span>{t('PrivateLayout.reminderBodyNewFree')} </span>
      <a
        title="Payments"
        href={getAppDashboardURL()}
        className="underline text-md-links hover:text-md-linksAlt"
      >
        {t('PrivateLayout.reminderNoBillingNewFree')}
      </a>
    </>
  );
};
